<ng-container *transloco="let t">
  <authority-labs-base-dialog [dialogRef]="dialogRef" [title]="title">
    <section content>
      <nz-select
        *ngIf="!readonly"
        nzPlaceHolder="בחר רשומה"
        nzShowSearch
        nzServerSearch
        nzAllowClear
        nzSize="large"
        nzDropdownClassName="dialog-dropdown"
        [nzOptionHeightPx]="optionHeight"
        [nzOptionOverflowSize]="optionsSize"
        [nzAutoFocus]="true"
        [nzSuffixIcon]="suffixIcon"
        [nzDropdownRender]="renderTemplate"
        [ngModel]="entity"
        (ngModelChange)="onSelect($event)"
        (nzOnSearch)="search($event)"
        (nzScrollToBottom)="loadMore()"
        class="select"
      >
        <nz-option
          *ngFor="let e of entities"
          [nzValue]="e"
          [nzLabel]="getLabel(e)"
          nzCustomContent
        >
          <ng-container
            *ngTemplateOutlet="optionTpl; context: { entity: e }"
          ></ng-container>
        </nz-option>
      </nz-select>

      <ng-container
        *ngTemplateOutlet="selectedTpl; context: { entity: entity }"
      ></ng-container>

      <ng-template #suffixIcon>
        <i nz-icon nzType="search"></i>
      </ng-template>

      <ng-template #renderTemplate>
        <nz-spin *ngIf="isLoading"></nz-spin>
      </ng-template>
    </section>

    <nz-space actions *ngIf="!readonly">
      <ng-template nzSpaceItem>
        <button
          nz-button
          nzType="primary"
          type="submit"
          [disabled]="!canSelect"
          (click)="selectEntity()"
        >
          {{ t('button.select') }}
        </button>
      </ng-template>
      <ng-template nzSpaceItem>
        <ng-container *ngIf="entityDialogService && canAdd">
          <button
            nz-button
            nzType="primary"
            type="submit"
            (click)="newEntity()"
          >
            {{ t('button.add') }}
          </button>
        </ng-container>
      </ng-template>

      <ng-template nzSpaceItem>
        <ng-container *ngIf="entityDialogService && canEdit">
          <button
            nz-button
            nzType="primary"
            type="submit"
            (click)="editEntity()"
          >
            {{ t('button.edit') }}
          </button>
        </ng-container>
      </ng-template>
      <ng-template nzSpaceItem></ng-template>
    </nz-space>
  </authority-labs-base-dialog>
</ng-container>
